import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import providers
import { AuthProvider } from './provider/AuthProvider';
import { EAuthProvider } from './employer/Provider/EAuthProvider';
import { AppTypeProvider } from './provider/AppTypeProvider';

// Import shared/public components
import MainSignup from './pages/MainSignup';
import About from './pages/About';
import FAQ from './pages/FAQ';
import { SignIn, SignUp, ForgotPassword } from './pages/(auth)';

// Import route components directly to avoid circular imports
import StudentRoutes from './components/Layout/StudentRoutes';
import EmployerRoutes from './employer/Layout/EmployerRoutes';

function App() {
  return (
    <AppTypeProvider>
      <Router>
        <Routes>
          {/* Public routes - accessible to both */}
          <Route path="/main-signup" element={<MainSignup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          
          {/* Employer routes - must come BEFORE student routes */}
          <Route path="/employer/*" element={
            <EAuthProvider>
              <EmployerRoutes />
            </EAuthProvider>
          } />
          
          {/* Student routes - catches everything else */}
          <Route path="/*" element={
            <AuthProvider>
              <StudentRoutes />
            </AuthProvider>
          } />
        </Routes>
      </Router>
    </AppTypeProvider>
  );
}

export default App;